/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_SubtitleInputs */

const es_home_cta_subtitle = /** @type {(inputs: Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descubrí lo que tu empresa ya sabe. Conecta tu primera fuente gratis y empieza a encontrar la información que importa.`)
};

const en_home_cta_subtitle = /** @type {(inputs: Home_Cta_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discover what your company already knows. Connect your first source for free and start finding the information that matters.`)
};

/**
* | output |
* | --- |
* | "Discover what your company already knows. Connect your first source for free and start finding the information that matters." |
*
* @param {Home_Cta_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_cta_subtitle = /** @type {((inputs?: Home_Cta_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_cta_subtitle(inputs)
	return en_home_cta_subtitle(inputs)
});
export { home_cta_subtitle as "home.cta.subtitle" }